/*!
 * Copyright © 2005-2025 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ThemeService } from './theme.service';

/** Bottom-of-sidebar row: a moon/sun icon, a Dark/Light Mode label and a switch. */
@Component({
  selector: 'app-theme-toggle-row',
  standalone: true,
  imports: [MatIconModule, MatSlideToggleModule],
  encapsulation: ViewEncapsulation.None,
  template: `
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <div class="aca-theme-row" (click)="theme.toggle()">
      <mat-icon class="aca-theme-row__icon">{{ theme.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
      <span class="aca-theme-row__label">{{ theme.isDark() ? 'Light Mode' : 'Dark Mode' }}</span>
      <mat-slide-toggle
        class="aca-theme-row__switch"
        [checked]="theme.isDark()"
        (click)="$event.stopPropagation()"
        (change)="theme.toggle()"
        [attr.aria-label]="theme.isDark() ? 'Switch to light theme' : 'Switch to dark theme'"
      />
    </div>
  `
})
export class ThemeToggleRowComponent {
  readonly theme = inject(ThemeService);
}
